import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "line-item line-item-title"
};
const _hoisted_2 = {
  class: "line-item line-item-title"
};
const _hoisted_3 = {
  class: "line-item"
};
import { onMounted, reactive } from "vue";
import apis from "@/api";
import common from "../composables/common";
export default {
  __name: 'PrintedTimeline',
  props: {
    demandId: {
      type: String
    }
  },
  setup(__props) {
    const props = __props;
    const {
      srcProcs
    } = common();
    const data = reactive({
      processLogs: []
    });
    const processLog = () => {
      if (props.demandId) {
        apis.processLog({
          demandId: props.demandId
        }).then(res => {
          if (res.success && res.data && res.data.length > 0) {
            for (const d of res.data) {
              if (d.title != '需求进行中') {
                data.processLogs.push(d);
              }
            }
          } else {
            ElMessage.error(res.msg);
          }
        });
      } else {
        for (const d of srcProcs) {
          if (d.content != '需求进行中') {
            data.processLogs.push(d);
          }
        }
      }
      console.log(data.processLogs);
    };
    onMounted(() => {
      processLog();
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_timeline_item = _resolveComponent("el-timeline-item");
      const _component_el_timeline = _resolveComponent("el-timeline");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      return _openBlock(), _createBlock(_component_el_scrollbar, {
        height: "100%"
      }, {
        default: _withCtx(() => [props.demandId ? (_openBlock(), _createBlock(_component_el_timeline, {
          key: 0
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.processLogs, (proc, index) => {
            return _openBlock(), _createBlock(_component_el_timeline_item, {
              key: index,
              type: proc.type,
              timestamp: proc.optTime
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(proc.title), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(proc.items, (item, ind) => {
                return _openBlock(), _createElementBlock("div", {
                  key: ind
                }, [item && item.length > 0 ? (_openBlock(), _createBlock(_component_el_row, {
                  key: 0,
                  class: "line-item"
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 7
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item[0]) + " : ", 1)]),
                    _: 2
                  }, 1024), _createVNode(_component_el_col, {
                    span: 17
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item[1]), 1)]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1024)) : _createCommentVNode("", true)]);
              }), 128))]),
              _: 2
            }, 1032, ["type", "timestamp"]);
          }), 128))]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_timeline, {
          key: 1
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.processLogs, (proc, index) => {
            return _openBlock(), _createBlock(_component_el_timeline_item, {
              key: index,
              type: proc.type,
              color: proc.color,
              timestamp: proc.timestamp
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString(proc.content), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(proc.opterName), 1)]),
              _: 2
            }, 1032, ["type", "color", "timestamp"]);
          }), 128))]),
          _: 1
        }))]),
        _: 1
      });
    };
  }
};